import {
  Flex,
  type FlexProps,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Text,
} from '@/ui';

type Props = FlexProps & {
  colorScheme?: string;
  isDisabled?: boolean;
  scale: number;
  onScaleChange: (value: number) => void;
};

export const ZoomSlider = ({
  colorScheme = 'purple',
  scale,
  isDisabled,
  onScaleChange,
  ...props
}: Props) => {
  return (
    <Flex align="center" gap="4" pl="2" {...props}>
      <Slider
        aria-label="Zoom level"
        colorScheme={colorScheme}
        defaultValue={1}
        isDisabled={isDisabled}
        max={2}
        min={1}
        minW="120px"
        step={0.01}
        onChange={onScaleChange}
      >
        <SliderTrack bg="gray.400" borderRadius="lg" h="4px">
          <SliderFilledTrack />
        </SliderTrack>
        <SliderThumb
          bg={`${colorScheme}.300`}
          borderColor={`${colorScheme}.400`}
          boxSize="14px"
        />
      </Slider>
      <Text
        bg="gray.100"
        borderRadius="md"
        flexShrink="0"
        fontSize="xs"
        py="1"
        textAlign="center"
        w="45px"
      >
        {Math.round(scale * 100)}%
      </Text>
    </Flex>
  );
};
